<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
    <div class="container-header-inner">
        <div class="title-wrapper mb-4">
            <div>
                <h1 class="title-default">Relatório de Contas a Pagar</h1>
                <p class="welcome-message">
                    <button mat-icon-button type="button" (click)="voltar()"
                        aria-label="Voltar para relatórios de finanças">
                        <mat-icon>arrow_back</mat-icon>
                    </button>
                    Consulte suas contas a pagar por período, situação, agrupamento e categoria.
                </p>
            </div>
        </div>

        @if (carregandoLookups) {
        <div class="row">
            <div class="col-12 mb-4">
                <app-loading-box [height]="'30'" [width]="'250'" [margin]="'0 0 20px 0'"></app-loading-box>
                <div class="row">
                    <div class="col-12 mb-3">
                        <app-loading-box [height]="'150'"></app-loading-box>
                    </div>
                    <div class="col-md-6 col-12 mb-3">
                        <app-loading-box [height]="'100'"></app-loading-box>
                    </div>
                </div>
            </div>
        </div>
        } @else {

        <section class="section-container filtros-section" [class.filtros-hidden]="!filtrosVisiveis">
            <div class="filtros-heading">
                <div class="filtros-heading-title">
                    <mat-icon class="material-symbols-outlined">filter_alt</mat-icon>
                    <span>Filtros de pesquisa</span>
                </div>
                <div class="favoritos-toolbar">
                    <mat-form-field appearance="outline" class="favoritos-field" subscriptSizing="dynamic">
                        <mat-label>Filtros favoritos</mat-label>
                        <mat-select [formControl]="$any(form.controls['favoritoSelecionado'])"
                            (selectionChange)="carregarFavoritoSelecionado()">
                            <mat-option [value]="null">Selecionar favorito</mat-option>
                            @for (favorito of favoritos; track favorito.idRelatorioFiltroFavorito) {
                            <mat-option [value]="getFavoritoValue(favorito)">{{ favorito.nome }}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>

                    @if (hasFavoritoSelecionado || hasAlgumFiltroPreenchido) {
                    <button type="button" mat-stroked-button class="btn-secondary favoritar-button"
                        (click)="favoritarFiltros()">
                        <mat-icon class="material-symbols-outlined">
                            {{ hasFavoritoSelecionado ? 'delete' : 'star' }}
                        </mat-icon>
                        {{ hasFavoritoSelecionado ? 'Remover favorito' : 'Favoritar filtros' }}
                    </button>
                    }
                </div>
            </div>

            <form [formGroup]="form" class="filtros-body">
                <div class="row g-3">
                    <div class="col-xl-4 col-lg-5 col-12 border-end-desktop">
                        <div class="d-flex flex-column gap-3 h-100">
                            <div class="field-group mb-0 campo-periodo">
                                <label class="field-caption mb-3">Período de vencimento</label>
                                <div class="periodo-toggle mb-0">
                                    @for (opcao of periodoOpcoes; track opcao.id) {
                                    <button type="button" class="periodo-chip"
                                        [class.periodo-chip-active]="form.get('modoPeriodo')?.value === opcao.id"
                                        (click)="selecionarModoPeriodo(opcao.id)">
                                        {{ opcao.descricao }}
                                    </button>
                                    }
                                </div>
                            </div>

                            <div class="flex-grow-1">
                                @if (isModoMes) {
                                <div class="mes-picker">
                                    <mat-form-field appearance="outline" subscriptSizing="dynamic"
                                        class="w-100 mes-picker-field">
                                        <button matPrefix type="button" mat-icon-button class="mes-nav-btn"
                                            (click)="navegarMes(-1)" aria-label="Mês anterior">
                                            <mat-icon>chevron_left</mat-icon>
                                        </button>
                                        <input matInput class="text-center mes-input-fw" formControlName="mesAno"
                                            placeholder="MM/AAAA" (blur)="normalizarMesAno()" autocomplete="off">
                                        <button matSuffix type="button" mat-icon-button class="mes-nav-btn"
                                            (click)="navegarMes(1)" aria-label="Próximo mês">
                                            <mat-icon>chevron_right</mat-icon>
                                        </button>
                                    </mat-form-field>
                                </div>
                                } @else {
                                <div class="intervalo-grid">
                                    <mat-form-field appearance="outline" subscriptSizing="dynamic">
                                        <mat-label>Data inicial</mat-label>
                                        <input matInput [matDatepicker]="pickerInicio" formControlName="dataInicial"
                                            (input)="onDateInput($event, 'dataInicial')" placeholder="DD/MM/AAAA">
                                        <mat-datepicker-toggle matIconSuffix
                                            [for]="pickerInicio"></mat-datepicker-toggle>
                                        <mat-datepicker #pickerInicio></mat-datepicker>
                                    </mat-form-field>
                                    <mat-form-field appearance="outline" subscriptSizing="dynamic">
                                        <mat-label>Data final</mat-label>
                                        <input matInput [matDatepicker]="pickerFim" formControlName="dataFinal"
                                            (input)="onDateInput($event, 'dataFinal')" placeholder="DD/MM/AAAA">
                                        <mat-datepicker-toggle matIconSuffix [for]="pickerFim"></mat-datepicker-toggle>
                                        <mat-datepicker #pickerFim></mat-datepicker>
                                    </mat-form-field>
                                </div>
                                }
                            </div>
                        </div>
                    </div>

                    <div class="col-xl-8 col-lg-7 col-12">
                        <div class="row g-3">
                            <div class="col-md-6 col-12">
                                <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                                    <mat-label>Situação</mat-label>
                                    <mat-select formControlName="situacoes" multiple>
                                        @for (op of situacaoOpcoes; track op.id) {
                                        <mat-option [value]="op.id">{{ op.descricao }}</mat-option>
                                        }
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="col-md-6 col-12">
                                <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                                    <mat-label>Agrupar por</mat-label>
                                    <mat-select formControlName="agrupamento">
                                        @for (op of agrupamentoOpcoes; track op.id) {
                                        <mat-option [value]="op.id">{{ op.descricao }}</mat-option>
                                        }
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="col-12">
                                <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                                    <mat-label>Categoria</mat-label>
                                    <mat-select formControlName="idCategoriaFinanceira">
                                        <mat-option [value]="null">Todos</mat-option>
                                        @for (cat of categorias; track cat.idCategoriaFinanceira) {
                                        <mat-option [value]="cat.idCategoriaFinanceira">{{ getCategoriaLabel(cat)
                                            }}</mat-option>
                                        }
                                    </mat-select>
                                </mat-form-field>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="filtros-footer">
                    <button type="button" mat-flat-button class="btn-primary" (click)="gerar()"
                        [disabled]="carregandoLookups || carregandoRelatorio">
                        @if (!carregandoRelatorio) {
                        <mat-icon>search</mat-icon>
                        Gerar
                        } @else {
                        <mat-spinner diameter="20"></mat-spinner>
                        }
                    </button>
                </div>
            </form>
        </section>

        @if (carregandoRelatorio) {
        <div class="row">
            <div class="col-12 mb-4">
                <app-loading-box [height]="'48'" [margin]="'0 0 20px 0'"></app-loading-box>
                <app-loading-box [height]="'300'"></app-loading-box>
            </div>
        </div>
        } @else if (consultaGerada && possuiResultados) {

        <section class="toolbar-card">
            <div class="toolbar-actions">
                @if (!filtrosVisiveis) {
                <button type="button" mat-flat-button class="btn-primary" (click)="toggleFiltros()">
                    <mat-icon>tune</mat-icon>
                    Exibir filtros
                </button>
                } @else {
                <button type="button" mat-stroked-button class="btn-secondary" (click)="toggleFiltros()">
                    <mat-icon>tune</mat-icon>
                    Ocultar filtros
                </button>
                }
                <button type="button" mat-stroked-button class="btn-secondary icon-only" (click)="imprimir()"
                    matTooltip="Imprimir">
                    <mat-icon>print</mat-icon>
                </button>
                <button type="button" mat-stroked-button class="btn-secondary icon-only" (click)="downloadCsv()"
                    matTooltip="Download CSV">
                    <mat-icon>download</mat-icon>
                </button>
            </div>
        </section>

        <section class="resultado-section">

            @if (agrupamentoAtual === 'nenhum') {
            <!-- Flat list -->
            <article class="tabela-card detalhes-card">
                <div class="detalhes-header">
                    <mat-icon>receipt_long</mat-icon>
                    <span>Contas a Pagar</span>
                </div>
                <div class="detalhes-grupo">
                    <table class="detalhes-table">
                        <thead>
                            <tr>
                                <th class="col-fornecedor">Fornecedor</th>
                                <th class="col-historico">Descrição</th>
                                <th class="col-categoria">Categoria</th>
                                <th class="col-nrodoc">Nº Doc.</th>
                                <th class="col-data">Emissão</th>
                                <th class="col-data">Vencimento</th>
                                <th class="col-moeda text-end">Valor</th>
                                <th class="col-moeda text-end">Saldo</th>
                                <th class="col-moeda text-end">Pago</th>
                            </tr>
                        </thead>
                        <tbody>
                            @for (item of listaItens; track item.idContasPagarParcela) {
                            <tr [class.row-atrasada]="item.isAtrasada">
                                <td class="col-fornecedor">{{ item.fornecedor }}</td>
                                <td class="col-historico">{{ item.historico }}</td>
                                <td class="col-categoria">{{ item.categoria }}</td>
                                <td class="col-nrodoc">{{ item.nroDocumento || '—' }}</td>
                                <td class="col-data">{{ formatarData(item.dataEmissao) }}</td>
                                <td class="col-data">{{ formatarData(item.dataVencimento) }}</td>
                                <td class="col-moeda text-end">{{ formatarMoeda(item.valor) }}</td>
                                <td class="col-moeda text-end">{{ formatarMoeda(item.saldo) }}</td>
                                <td class="col-moeda text-end">{{ formatarMoeda(item.pago) }}</td>
                            </tr>
                            }
                            @if (listaItens.length === 0) {
                            <tr>
                                <td colspan="9" class="detalhes-empty">Nenhum registro encontrado.</td>
                            </tr>
                            }
                        </tbody>
                        <tfoot>
                            <tr class="total-row">
                                <td colspan="6"><strong>Total</strong></td>
                                <td class="col-moeda text-end"><strong>{{ formatarMoeda(totalValor) }}</strong></td>
                                <td class="col-moeda text-end"><strong>{{ formatarMoeda(totalSaldo) }}</strong></td>
                                <td class="col-moeda text-end"><strong>{{ formatarMoeda(totalPago) }}</strong></td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </article>
            } @else {
            <!-- Grouped -->
            @for (grupo of listaGrupos; track grupo.descricaoGrupo) {
            <article class="tabela-card detalhes-card detalhes-grupo-card">
                <div class="detalhes-header">
                    <mat-icon>{{ getIconoAgrupamento() }}</mat-icon>
                    <span>{{ grupo.descricaoGrupo || '—' }}</span>
                    <span class="detalhes-header-subtotals">
                        <span class="subtotal-chip">Valor: <strong>{{ formatarMoeda(grupo.subtotalValor)
                                }}</strong></span>
                        <span class="subtotal-chip">Saldo: <strong>{{ formatarMoeda(grupo.subtotalSaldo)
                                }}</strong></span>
                        <span class="subtotal-chip">Pago: <strong>{{ formatarMoeda(grupo.subtotalPago)
                                }}</strong></span>
                    </span>
                </div>
                <div class="detalhes-grupo">
                    <table class="detalhes-table">
                        <thead>
                            <tr>
                                <th class="col-fornecedor">Fornecedor</th>
                                <th class="col-historico">Descrição</th>
                                <th class="col-categoria">Categoria</th>
                                <th class="col-nrodoc">Nº Doc.</th>
                                <th class="col-data">Emissão</th>
                                <th class="col-data">Vencimento</th>
                                <th class="col-moeda text-end">Valor</th>
                                <th class="col-moeda text-end">Saldo</th>
                                <th class="col-moeda text-end">Pago</th>
                            </tr>
                        </thead>
                        <tbody>
                            @for (item of grupo.itens; track item.idContasPagarParcela) {
                            <tr [class.row-atrasada]="item.isAtrasada">
                                <td class="col-fornecedor">{{ item.fornecedor }}</td>
                                <td class="col-historico">{{ item.historico }}</td>
                                <td class="col-categoria">{{ item.categoria }}</td>
                                <td class="col-nrodoc">{{ item.nroDocumento || '—' }}</td>
                                <td class="col-data">{{ formatarData(item.dataEmissao) }}</td>
                                <td class="col-data">{{ formatarData(item.dataVencimento) }}</td>
                                <td class="col-moeda text-end">{{ formatarMoeda(item.valor) }}</td>
                                <td class="col-moeda text-end">{{ formatarMoeda(item.saldo) }}</td>
                                <td class="col-moeda text-end">{{ formatarMoeda(item.pago) }}</td>
                            </tr>
                            }
                            @if (grupo.itens.length === 0) {
                            <tr>
                                <td colspan="9" class="detalhes-empty">Nenhum registro encontrado.</td>
                            </tr>
                            }
                        </tbody>
                    </table>
                </div>
            </article>
            }

            <!-- Total geral -->
            <article class="total-geral-card">
                <div class="total-geral-inner">
                    <span class="total-geral-label">Total Geral</span>
                    <div class="total-geral-valores">
                        <div class="total-geral-item">
                            <span class="total-geral-item-label">Valor</span>
                            <span class="total-geral-item-valor">{{ formatarMoeda(totalValor) }}</span>
                        </div>
                        <div class="total-geral-item">
                            <span class="total-geral-item-label">Saldo</span>
                            <span class="total-geral-item-valor">{{ formatarMoeda(totalSaldo) }}</span>
                        </div>
                        <div class="total-geral-item">
                            <span class="total-geral-item-label">Pago</span>
                            <span class="total-geral-item-valor total-geral-pago">{{ formatarMoeda(totalPago) }}</span>
                        </div>
                    </div>
                </div>
            </article>
            }

        </section>

        } @else if (consultaGerada && !possuiResultados && mensagemEmptyState) {
        <app-empty-list [title]="'A consulta não retornou nenhum registro.'"
            [subTitle]="'Tente refazer a consulta com outros parâmetros.'"></app-empty-list>
        }

        }
    </div>
</div>